import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { record_type, option_type, string_type, class_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Result_isOk, ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Return_1505, ResultComputationExpression_ResultBuilder__Bind_764BA1D3, ResultComputationExpression_ResultBuilder__Delay_1505, ResultComputationExpression_ResultBuilder__Run_FCFD9EF } from "../../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { validateNotEmptyGuid } from "../../fable_modules/Webbler.Models.1.6.0/Validation.fs.js";
import { ErrorMessage } from "../ErrorMessage.js";
import { StudyValidators_validateDateInPast, StudyValidators_validateStringNotNullOrWhiteSpace, StudyValidators_validateIfSome } from "./Study.js";

export class PatientInformationViewModel extends Record {
    constructor(studyId, patientName, mrn, dateOfBirth, referringPhysician, scanAcquisitionDate, patientSex) {
        super();
        this.studyId = studyId;
        this.patientName = patientName;
        this.mrn = mrn;
        this.dateOfBirth = dateOfBirth;
        this.referringPhysician = referringPhysician;
        this.scanAcquisitionDate = scanAcquisitionDate;
        this.patientSex = patientSex;
    }
}

export function PatientInformationViewModel_$reflection() {
    return record_type("RAWMap.Models.View.PatientInformationViewModel", [], PatientInformationViewModel, () => [["studyId", class_type("System.Guid")], ["patientName", option_type(string_type)], ["mrn", option_type(string_type)], ["dateOfBirth", option_type(class_type("System.DateTimeOffset"))], ["referringPhysician", option_type(string_type)], ["scanAcquisitionDate", option_type(class_type("System.DateTimeOffset"))], ["patientSex", option_type(string_type)]]);
}

export function PatientInformationViewModel_validate_Z132EAB41(vm) {
    return ResultComputationExpression_ResultBuilder__Run_FCFD9EF(ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Delay_1505(ResultComputationExpression_result, () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, validateNotEmptyGuid(new ErrorMessage(6, ["StudyId", "not be empty Guid"]), vm.studyId), () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, StudyValidators_validateIfSome((fieldValue) => StudyValidators_validateStringNotNullOrWhiteSpace("PatientName", fieldValue), vm.patientName), () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, StudyValidators_validateIfSome((fieldValue_1) => StudyValidators_validateStringNotNullOrWhiteSpace("Mrn", fieldValue_1), vm.mrn), () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, StudyValidators_validateIfSome((fieldValue_2) => StudyValidators_validateStringNotNullOrWhiteSpace("ReferringPhysician", fieldValue_2), vm.referringPhysician), () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, StudyValidators_validateIfSome((fieldValue_3) => StudyValidators_validateDateInPast("DateOfBirth", fieldValue_3), vm.dateOfBirth), () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, StudyValidators_validateIfSome((fieldValue_4) => StudyValidators_validateDateInPast("ScanAcquisitionDate", fieldValue_4), vm.scanAcquisitionDate), () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, StudyValidators_validateIfSome((fieldValue_5) => StudyValidators_validateStringNotNullOrWhiteSpace("PatientSex", fieldValue_5), vm.patientSex), () => ResultComputationExpression_ResultBuilder__Return_1505(ResultComputationExpression_result, vm))))))))));
}

export function PatientInformationViewModel_isValid_Z132EAB41(vm) {
    return Result_isOk(PatientInformationViewModel_validate_Z132EAB41(vm));
}

export function PatientInformationViewModel_getStudyId_Z132EAB41(vm) {
    return vm.studyId;
}

export function PatientInformationViewModel_getPrimaryId_Z132EAB41(vm) {
    return vm.studyId;
}

export function PatientInformationViewModel_get_primaryIdName() {
    return "StudyId";
}

export function PatientInformationViewModel_get_description() {
    return "Patient Information";
}

export function PatientInformationViewModel_desc_Z132EAB41(_arg) {
    return PatientInformationViewModel_get_description();
}

export function PatientInformationViewModel_isOnlyAcquisitionDateSet_Z132EAB41(vm) {
    if (((((vm.patientName == null) && (vm.mrn == null)) && (vm.dateOfBirth == null)) && (vm.referringPhysician == null)) && (vm.scanAcquisitionDate != null)) {
        return vm.patientSex == null;
    }
    else {
        return false;
    }
}

export function PatientInformationViewModel_isOnlyDobAndAcquisitionDateSet_Z132EAB41(vm) {
    if (((((vm.patientName == null) && (vm.mrn == null)) && (vm.dateOfBirth != null)) && (vm.referringPhysician == null)) && (vm.scanAcquisitionDate != null)) {
        return vm.patientSex == null;
    }
    else {
        return false;
    }
}

